<template>
  <div class="modal-content">
    <div class="modal-body">
      <suspense>
        <component-details :baseDomain="baseDomain" :shopId="shopId" :apiKey="apiKey" :component="component" v-on:close="hideModal" v-on:save="save" v-on:unlinkComponent="unlinkComponent" />
      </suspense>
    </div>
  </div>
</template>

<script>

export default {
  props: ['baseDomain', 'shopId', 'apiKey', 'component'],
  methods: {
    hideModal () {
      this.$emit('close')
    },
    unlinkComponent (id) {
      this.$emit('unlinkComponent', id)
    },
    save (component) {
      this.$emit('save', component)
    }
  }
}

</script>